import React, { useEffect } from "react";
import { Button } from "@material-ui/core";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";

const ModalBase = (props) => {
  const { content, open, setOpen, maxWidth } = props;

  useEffect(()=>{
    
  }, [open])
  return (
    <Dialog
      open={open}
      onClose={() => setOpen(false)}
      aria-labelledby="dialog-title"
      fullWidth
      maxWidth={ maxWidth ?? "xl" }
    >
      <DialogContent>
        <DialogContentText>{content}</DialogContentText>
      </DialogContent>
      <DialogActions>
      </DialogActions>
    </Dialog>
  );
};

export default ModalBase;
